import {t} from "@lingui/core/macro";
import {StyleSheet, type CSSProperties} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {PhosphorIcon} from "@khanacademy/wonder-blocks-icon";
import {color} from "@khanacademy/wonder-blocks-tokens";
import type {Reaction} from "@khan/guide-types";

import {REACTION_BADGE_SIZE} from "./constants.ts";
import emojiForReaction from "./utils/emoji-for-reaction.ts";

interface Props {
    reaction: Reaction;
    style?: CSSProperties;
}

const MessageReactionBadge = (props: Props): React.ReactElement | null => {
    const {reaction, style} = props;

    const emoji = emojiForReaction(reaction);
    if (!emoji) {
        return null;
    }

    const sentiments = {
        "thumbs-up": t`thumbs-up`,
        "thumbs-down": t`thumbs-down`,
    };

    return (
        <View style={[styles.badge, style]} testId={`msg-label-${reaction}`}>
            <PhosphorIcon
                aria-label={sentiments[reaction]}
                icon={emoji}
                color={color.offBlack64}
                testId={`msg-label-${reaction}`}
            />
        </View>
    );
};

const styles = StyleSheet.create({
    badge: {
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 4,
        backgroundColor: color.white,
        boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.1)",
        width: REACTION_BADGE_SIZE,
        height: REACTION_BADGE_SIZE,
    },
});

export {MessageReactionBadge};
